import { useTranslation } from 'react-i18next';

function splitParagraphs(text: string): string[] {
  return text.split(/\n{2,}/);
}

export default function JobDefinition() {
  const { t } = useTranslation();

  const blocks = [
    { sub: 'butlerJob.definition.sub1', para: 'butlerJob.definition.para1' },
    { sub: 'butlerJob.definition.sub2', para: 'butlerJob.definition.para2' },
    { sub: 'butlerJob.definition.sub3', para: 'butlerJob.definition.para3' },
  ];

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[860px] mx-auto px-8 md:px-12">
        <div className="text-center mb-12">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            {t('butlerJob.definition.label')}
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('butlerJob.definition.title')}
          </h2>
          <p className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">
            {t('butlerJob.definition.titleEn')}
          </p>
          <div className="gold-line mx-auto"></div>
        </div>

        {splitParagraphs(t('butlerJob.definition.mainLine')).map((paragraph, index) => (
          <p key={index} className="font-heading text-[19px] md:text-[22px] text-foreground-900 tracking-[0.06em] leading-relaxed text-center mb-12">
            {paragraph}
          </p>
        ))}

        <div className="space-y-9">
          {blocks.map((block, idx) => (
            <div key={idx}>
              <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em] mb-3 pl-4 border-l-2 border-accent-500/50">
                {t(block.sub)}
              </h3>
              {splitParagraphs(t(block.para)).map((paragraph, index) => (
                <p key={index} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-[1.9]">
                  {paragraph}
                </p>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
